var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup130(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    viewBox: "0 0 58 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "#1BABE2",
    stroke: "#1BABE2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 28H30.3335V29.75H35.0002V28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 31.5H30.3335V33.25H35.0002V31.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3335 22.1667H31.5002V18.6667C31.5002 17.3834 30.4502 16.3334 29.1668 16.3334H26.8335C25.5502 16.3334 24.5002 17.3834 24.5002 18.6667V22.1667H18.6668C17.3835 22.1667 16.3335 23.2167 16.3335 24.5V37.3334C16.3335 38.6167 17.3835 39.6667 18.6668 39.6667H37.3335C38.6168 39.6667 39.6668 38.6167 39.6668 37.3334V24.5C39.6668 23.2167 38.6168 22.1667 37.3335 22.1667ZM26.8335 22.1667V18.6667H29.1668V22.1667V24.5H26.8335V22.1667ZM37.3335 37.3334H18.6668V24.5H24.5002C24.5002 25.7834 25.5502 26.8334 26.8335 26.8334H29.1668C30.4502 26.8334 31.5002 25.7834 31.5002 24.5H37.3335V37.3334Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 31.5C25.4665 31.5 26.25 30.7165 26.25 29.75C26.25 28.7835 25.4665 28 24.5 28C23.5335 28 22.75 28.7835 22.75 29.75C22.75 30.7165 23.5335 31.5 24.5 31.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9267 32.8767C26.18 32.55 25.3633 32.375 24.5 32.375C23.6367 32.375 22.82 32.55 22.0733 32.8767C21.42 33.1567 21 33.7867 21 34.4983V35H28V34.4983C28 33.7867 27.58 33.1567 26.9267 32.8767Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 49,
    r: 12,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 40C41.05 40 37 44.05 37 49C37 53.95 41.05 58 46 58C50.95 58 55 53.95 55 49C55 44.05 50.95 40 46 40ZM51.04 46.48L45.01 52.51C44.92 52.6 44.74 52.69 44.56 52.69C44.38 52.69 44.2 52.6 44.02 52.51L41.32 49.81C41.05 49.54 41.05 49.09 41.32 48.82C41.59 48.55 42.04 48.55 42.31 48.82L44.56 51.07L50.05 45.58C50.32 45.31 50.77 45.31 51.04 45.58C51.31 45.85 51.31 46.21 51.04 46.48Z",
    fill: "#98CD6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup130);
export default __webpack_public_path__ + "static/media/Group130.863e9188.svg";
export { ForwardRef as ReactComponent };